import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";
import { AuthProvider } from "./lib/auth";
import { keepAppFresh } from "./lib/refresh";
import { ConfirmProvider } from "./lib/confirm";
import { MediaDownloadProvider } from "./lib/media/download";
import { MediaTasksProvider } from "./lib/mediaTasks";
import { ProfileNavProvider } from "./lib/profileNav";
import { ScheduleNavProvider } from "./lib/scheduleNav";
import { initTheme } from "./lib/theme";
import { ToastProvider } from "./lib/toast";

keepAppFresh();
// 描画前に反映して、起動直後に色が切り替わって見えるのを避ける
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root が見つかりません");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <MediaTasksProvider>
            {/* 保存のしかたを選ぶシートを出すため、進捗を持つ MediaTasks の内側に置く */}
            <MediaDownloadProvider>
              <ScheduleNavProvider>
                <ProfileNavProvider>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </ProfileNavProvider>
              </ScheduleNavProvider>
            </MediaDownloadProvider>
          </MediaTasksProvider>
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
